module.exports = __webpack_public_path__ + "img/tuts-rating-slider-mobile-1.8fd50f69.png";